import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

const SectionSwitcher = ({ options, activeIndex, onSelectIndex }: Props) => {
	const onClick = (index: number) => () => onSelectIndex(index);
	return (
		<Wrapper>
			{options.map((option, i) => (
				<button key={option} onClick={onClick(i)} className={classNames(i === activeIndex && 'active')}>
					{option}
				</button>
			))}
		</Wrapper>
	);
};

export default SectionSwitcher;

interface Props {
	options: Array<string>;
	activeIndex: number;
	onSelectIndex: (index: number) => void;
}

const Wrapper = styled.div(
	({ theme }) => `
	display: flex;
	justify-content: center;

	button {
		font-weight: 700;
		border-bottom: 5px solid ${theme.colors.light};
        margin .5rem 2.5%;
        padding: 1rem 0;
        outline: none;

        &.active {
			border-bottom-color: ${theme.colors.primary};
		}
	}
`
);
